import { CTAPair } from "./CTAButtons";
import { Reveal } from "./Reveal";

export function CTABand({ title = "Your Brakes. Your Driveway. Done Today.", sub }) {
  return (
    <section data-testid="cta-band" className="relative overflow-hidden bg-crimson">
      <div
        aria-hidden="true"
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "repeating-linear-gradient(-45deg, #000 0, #000 2px, transparent 2px, transparent 18px)",
        }}
      />
      <div className="relative mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-20">
        <Reveal>
          <h2 className="max-w-3xl font-display text-3xl font-black uppercase leading-[0.95] tracking-tight text-white sm:text-5xl">
            {title}
          </h2>
          {sub && <p className="mt-3 max-w-xl text-base text-white/85">{sub}</p>}
          <div className="mt-8 flex flex-col gap-3 sm:flex-row [&_a]:!border-white [&>*>a:first-child]:!bg-white [&>*>a:first-child]:!text-[#1877F2] [&>*>a:first-child]:hover:!bg-[#E7F3FF] [&>*>a:last-child]:!text-white">
            <CTAPair />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
